import React from 'react';

import Customer from './pages';

import { qbeTheme, ThemeProvider, ADSLocaleProvider } from '@qbe/ads-core';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { FormProvider } from 'contexts/FormProvider';
import { CssBaseline } from '@mui/material';
import { setAppPartner } from 'hooks/useAnalytics';
import { ContentContextProvider } from '@qbe/dfc-content';
import { configAnalytics } from '@qbe/qal';

import cmsCustomer from './resources/cmsCustomer';

configAnalytics({
  appName: 'cms customer',
  basePagePath: '/au/about/governance/complaints/customer-relations',
  adsEngagementTracking: false,
});

// Get default white labelling partner from pathname if valid
setAppPartner('qbe');
interface MainAppProps {
  children: React.ReactNode;
}

export function MainApp({ children }: MainAppProps) {
  return (
    <ADSLocaleProvider dateAdapter={AdapterDayjs}>
      <ContentContextProvider data={cmsCustomer}>
        <ThemeProvider theme={qbeTheme}>{children}</ThemeProvider>
      </ContentContextProvider>
    </ADSLocaleProvider>
  );
}

const App = () => {
  return (
    <ADSLocaleProvider dateAdapter={AdapterDayjs}>
      <FormProvider>
        <CssBaseline />
        <ThemeProvider theme={qbeTheme}>
          <ContentContextProvider data={cmsCustomer}>
            <Customer />
          </ContentContextProvider>
        </ThemeProvider>
      </FormProvider>
    </ADSLocaleProvider>
  );
};

export default App;
